module.exports = __webpack_public_path__ + "static/media/complot-mobile.11c8ce3a.mp4";